import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../../shared/services/seo.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-hosting-info',
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule
  ],
  templateUrl: './hosting-info.html',
  styleUrl: './hosting-info.scss',
})
export class HostingInfo implements OnInit {
  private gtm = inject(GtmService);
  private seo = inject(SeoService);
  platformId = inject(PLATFORM_ID);
  displayedColumns: string[] = ['feature', 'horizinns', 'otherPlatforms'];
  
  dataSource = [
    { feature: 'Host Fee', horizinns: '$300/year flat', otherPlatforms: '3-15% per booking' },
    { feature: 'Renter Fee', horizinns: '$0', otherPlatforms: 'Up to 14% service fee' },
    { feature: 'Profit', horizinns: '100% of rental rate', otherPlatforms: 'Reduced by dual fees' },
    { feature: 'Control', horizinns: 'Full', otherPlatforms: 'Limited by platform rules' }
  ];

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/host',
        page_title: 'Hosting | Horizinns'
      });
    }
    this.seo.updateMetaTags('Hosting', 'Learn about the benefits of hosting your property on Horizinns', undefined, `${environment.appUrl}/host`);

    this.seo.addJsonLd({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Hosting",
      "description": "Learn about the benefits of hosting your property on Horizinns",
      "url": "${environment.appUrl}/host"
    });
  }
}
